import { groupLifeProposalsService } from '@/services/proposals/group-life';
import { downloadFromSignedUrl } from '@/shared/utils/signed-url.util';
import { useMutation } from '@tanstack/react-query';

/**
 * Baixa a carta comercial ASSINADA via DocuSign. O link é pedido na hora do
 * clique porque a URL pré-assinada expira em minutos.
 */
export function useDownloadGroupLifeSignedCommercialLetter(policyId: string) {
  return useMutation({
    mutationKey: ['group-life-proposal', policyId, 'signed-commercial-letter'],
    retry: false,
    mutationFn: async () => {
      const result =
        await groupLifeProposalsService.getSignedCommercialLetter(policyId);
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Erro ao baixar a carta comercial assinada'
        );
      }
      await downloadFromSignedUrl(
        result.data.url,
        result.data.fileName || `carta-comercial-assinada-${policyId}.pdf`
      );
      return result.data;
    },
  });
}
